'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { throttle } from 'es-toolkit';
import { motion, useAnimation } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';
interface MoreFloatingButtonProps {
  contentAreaSelector: string;
  recommendHometownNewsSelector: string;
  keyword: string;
}
export const MoreFloatingButton = t0 => {
  const $ = _c(32);
  const {
    contentAreaSelector,
    recommendHometownNewsSelector,
    keyword
  } = t0;
  const [contentsElement, setContentsElement] = useState();
  const [recommendHometownNewsElement, setRecommendHometownNewsElement] = useState();
  const [isShow, setIsShow] = useState(false);
  const controls = useAnimation();
  let t1;
  if ($[0] !== contentsElement || $[1] !== recommendHometownNewsElement) {
    t1 = () => {
      if (contentsElement === undefined || recommendHometownNewsElement === undefined) {
        return;
      }
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const contentsRect = contentsElement.getBoundingClientRect();
      const contentsTopFromDoc = contentsRect.top + scrollY;
      const recommendRect = recommendHometownNewsElement.getBoundingClientRect();
      const recommendTopFromDoc = recommendRect.top + scrollY;
      const isContentsScrollOveredHalf = contentsTopFromDoc + contentsElement.offsetHeight / 2 < scrollY + viewportHeight / 2;
      const isRecommendHometownNewsListScrollOvered = recommendTopFromDoc < scrollY + viewportHeight;
      setIsShow(isContentsScrollOveredHalf && !isRecommendHometownNewsListScrollOvered);
    };
    $[0] = contentsElement;
    $[1] = recommendHometownNewsElement;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const updateIsShow = t1;
  let t2;
  let t3;
  if ($[3] !== contentAreaSelector || $[4] !== recommendHometownNewsSelector) {
    t2 = () => {
      const contentsElement_0 = document.getElementById(contentAreaSelector);
      if (contentsElement_0) {
        setContentsElement(contentsElement_0);
      }
      const recommendHometownNewsElement_0 = document.getElementById(recommendHometownNewsSelector);
      if (recommendHometownNewsElement_0) {
        setRecommendHometownNewsElement(recommendHometownNewsElement_0);
      }
    };
    t3 = [contentAreaSelector, recommendHometownNewsSelector];
    $[3] = contentAreaSelector;
    $[4] = recommendHometownNewsSelector;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== contentsElement || $[8] !== recommendHometownNewsElement || $[9] !== updateIsShow) {
    t4 = () => {
      if (contentsElement && recommendHometownNewsElement) {
        updateIsShow();
      }
    };
    t5 = [contentsElement, recommendHometownNewsElement, updateIsShow];
    $[7] = contentsElement;
    $[8] = recommendHometownNewsElement;
    $[9] = updateIsShow;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== updateIsShow) {
    t6 = () => {
      const handleScroll = throttle(() => updateIsShow(), 200);
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t7 = [updateIsShow];
    $[12] = updateIsShow;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[15] !== controls || $[16] !== isShow) {
    t8 = () => {
      controls.start({
        opacity: isShow ? SHOW_BUTTON_OPACITY : INITIALIZE_BUTTON_OPACITY,
        bottom: isShow ? SHOW_BUTTON_BOTTOM : INITIALIZE_BUTTON_BOTTOM,
        transition: {
          duration: 0.2
        }
      });
    };
    t9 = [isShow, controls];
    $[15] = controls;
    $[16] = isShow;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  let t10;
  if ($[19] !== recommendHometownNewsElement) {
    t10 = () => {
      if (recommendHometownNewsElement === undefined) {
        return;
      }
      recommendHometownNewsElement.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    };
    $[19] = recommendHometownNewsElement;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const handleClick = t10;
  const t11 = !isShow;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: INITIALIZE_BUTTON_OPACITY,
      bottom: INITIALIZE_BUTTON_BOTTOM
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== keyword) {
    t13 = <p className="font-700 text-Gray-white typo-body4">{keyword} 소식 더보기</p>;
    $[22] = keyword;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SvgChevrondown className="size-14 text-Gray-white" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13) {
    t15 = <section className="flex h-40 w-full items-center justify-center gap-4 rounded-pill bg-Gray-black px-20">{t13}{t14}</section>;
    $[25] = t13;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== controls || $[28] !== handleClick || $[29] !== t11 || $[30] !== t15) {
    t16 = <motion.button animate={controls} className="fixed inset-x-0 mx-auto size-fit p-0" disabled={t11} initial={t12} type="button" onClick={handleClick}>{t15}</motion.button>;
    $[27] = controls;
    $[28] = handleClick;
    $[29] = t11;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
const INITIALIZE_BUTTON_OPACITY = 0;
const INITIALIZE_BUTTON_BOTTOM = -40;
const SHOW_BUTTON_OPACITY = 1;
const SHOW_BUTTON_BOTTOM = 10;